import { createReducer, on } from '@ngrx/store';
import { Task } from '../../models/task.model';
import * as fromTaskActions from '../actions/tasks.actions';

export interface TaskState {
    data: Task[];
    loaded: boolean;
    loading: boolean;
    error: string;
}

export const initialState: TaskState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: ''
};

export const taskReducer = createReducer(
    initialState,
    on(fromTaskActions.LoadTasksAction, (state) => ({ ...state, loading: true })),
    on(fromTaskActions.LoadTasksSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromTaskActions.LoadTasksFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromTaskActions.AddTaskAction, (state) => ({ ...state, loading: true })),
    on(fromTaskActions.AddTaskSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromTaskActions.AddTaskFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromTaskActions.DeleteTaskAction, (state) => ({ ...state, loading: true })),
    on(fromTaskActions.DeleteTaskSuccessAction, (state) => ({ ...state, data: undefined as any, loaded: true, loading: false })),
    on(fromTaskActions.DeleteTaskFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromTaskActions.UpdateTaskAction, (state) => ({ ...state, loading: true })),
    on(fromTaskActions.UpdateTaskSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromTaskActions.UpdateTaskFailAction, (state, { error }) => ({ ...state, error: error.message })),
);
